import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {HomeComponent} from './home/home.component';
import {ContentmainComponent} from './contentmain/contentmain.component';
import {AccountComponent} from './account/account.component';
import {AboutComponent} from './about/about.component';
import {FeaturedComponent} from './featured/featured.component';
import {ToollistComponent} from './toollist/toollist.component';
import {ThemesComponent} from './themes/themes.component';
import {SourcesComponent} from './sources/sources.component';
import {SearchappComponent} from './searchapp/searchapp.component';
import {SingleappComponent} from './singleapp/singleapp.component';
import {RecentchangesComponent} from './singleapp/recentchanges/recentchanges.component';
import {AuthorComponent} from './singleapp/author/author.component';
import {InstalledComponent} from './installed/installed.component';
import {ChangesComponent} from './changes/changes.component';
import {AppsourcesComponent} from './appsources/appsources.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'content/:id', component: ContentmainComponent },
  { path: 'content/subcontent/:id', component: ContentmainComponent },
  { path: 'account', component: AccountComponent },
  { path: 'account/:privilege', component: AccountComponent },
  { path: 'about', component: AboutComponent },
  { path: 'featured', component: FeaturedComponent },
  { path: 'toollist/:exid', component: ToollistComponent },
  { path: 'themes', component: ThemesComponent },
  { path: 'sources', component: SourcesComponent },
  { path: 'search', component: SearchappComponent },
  { path: 'singleapp/:appid', component: SingleappComponent },
  { path: 'singleapp/:appid/:redirection', component: SingleappComponent },
  { path: 'singleapp/changes/:appid', component: RecentchangesComponent },
  { path: 'singleapp/changes/:appid/:redirection', component: RecentchangesComponent },
  { path: 'singleapp/author/:appid', component: AuthorComponent },
  { path: 'singleapp/author/:appid/:redirection', component: AuthorComponent },
  { path: 'installed', component: InstalledComponent },
  { path: 'changes', component: ChangesComponent },
  { path: 'appsources', component: AppsourcesComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
